export const kmaToMarket = {
  AL_BIR: "Birmingham, AL",
  AL_DEC: "Decatur, AL",
  AL_MOB: "Mobile, AL",
  AL_MON: "Montgomery, AL",
  AR_FAY: "Fayetteville, AR",
  AR_LIT: "Little Rock, AR",
  AZ_FLA: "Flagstaff, AZ",
  AZ_PHO: "Phoenix, AZ",
  AZ_TUC: "Tucson, AZ",
  CA_FRS: "Fresno, CA",
  CA_LAX: "Los Angeles, CA",
  CA_ONT: "Ontario, CA",
  CA_SAN: "San Francisco, CA",
  CA_STK: "Stockton, CA",
  CO_DEN: "Denver, CO",
  CO_GRA: "Grand Jct, CO",
  CT_HAR: "Hartford, CT",
  FL_JAX: "Jacksonville, FL",
  FL_LAK: "Lakeland, FL",
  FL_MIA: "Miami, FL",
  FL_TAL: "Tallahassee, FL",
  GA_ATL: "Atlanta, GA",
  GA_MAC: "Macon, GA",
  GA_SAV: "Savannah, GA",
  GA_TIF: "Tifton, GA",
  IA_CED: "Cedar Rapids, IA",
  IA_DES: "Des Moines, IA",
  IA_DUB: "Dubuque, IA",
  ID_TWI: "Twin Falls, ID",
  IL_BLO: "Bloomington, IL",
  IL_CHI: "Chicago, IL",
  IL_JOL: "Joliet, IL",
  IL_QUI: "Quincy, IL",
  IL_ROC: "Rockford, IL",
  IL_TAY: "Taylorville, IL",
  IN_EVA: "Evansville, IN",
  IN_FTW: "Ft Wayne, IN",
  IN_GRY: "Gary, IN",
  IN_IND: "Indianapolis, IN",
  IN_SBD: "South Bend, IN",
  IN_TER: "Terre Haute, IN",
  KS_HUT: "Hutchinson, KS",
  KY_BOW: "Bowling Green, KY",
  KY_LEX: "Lexington, KY",
  KY_LOU: "Louisville, KY",
  LA_NEW: "New Orleans, LA",
  LA_SHR: "Shreveport, LA",
  MA_BOS: "Boston, MA",
  MA_SPR: "Springfield, MA",
  MD_BAL: "Baltimore, MD",
  ME_AUG: "Augusta, ME",
  MI_DET: "Detroit, MI",
  MI_RAP: "Grand Rapids, MI",
  MI_SAG: "Saginaw, MI",
  MN_DUL: "Duluth, MN",
  MN_MIN: "Minneapolis, MN",
  MN_STC: "St Cloud, MN",
  MO_GIR: "Cape Girardeau, MO",
  MO_JEF: "Jefferson City, MO",
  MO_JOP: "Joplin, MO",
  MO_KAN: "Kansas City, MO",
  MO_STL: "St Louis, MO",
  MS_JAC: "Jackson, MS",
  MT_BIL: "Billings, MT",
  MT_MIS: "Missoula, MT",
  NC_CHA: "Charlotte, NC",
  NC_GRE: "Greensboro, NC",
  NC_RAL: "Raleigh, NC",
  NC_WIL: "Wilmington, NC",
  ND_BIS: "Bismarck, ND",
  ND_FAR: "Fargo, ND",
  NE_NOR: "North Platte, NE",
  NE_OMA: "Omaha, NE",
  NH_BRI: "Bristol, NH",
  NJ_ELI: "Elizabeth, NJ",
  NM_ALB: "Albuquerque, NM",
  NV_LAS: "Las Vegas, NV",
  NV_REN: "Reno, NV",
  NY_ALB: "Albany, NY",
  NY_BRN: "Brooklyn, NY",
  NY_BUF: "Buffalo, NY",
  NY_ELM: "Elmira, NY",
  NY_ROC: "Rochester, NY",
  NY_SYR: "Syracuse, NY",
  OH_CIN: "Cincinnati, OH",
  OH_CLE: "Cleveland, OH",
  OH_COL: "Columbus, OH",
  OH_TOL: "Toledo, OH",
  OK_OKC: "Oklahoma City, OK",
  OK_TUL: "Tulsa, OK",
  OR_MED: "Medford, OR",
  OR_PEN: "Pendleton, OR",
  OR_POR: "Portland, OR",
  PA_ALL: "Allentown, PA",
  PA_ERI: "Erie, PA",
  PA_HAR: "Harrisburg, PA",
  PA_PHI: "Philadelphia, PA",
  PA_PIT: "Pittsburgh, PA",
  SC_COL: "Columbia, SC",
  SC_GRE: "Greenville, SC",
  SC_CHA: "N Charleston, SC",
  SD_RAP: "Rapid City, SD",
  SD_SIO: "Sioux Falls, SD",
  TN_CHA: "Chattanooga, TN",
  TN_KNO: "Knoxville, TN",
  TN_MEM: "Memphis, TN",
  TN_NAS: "Nashville, TN",
  TX_AMA: "Amarillo, TX",
  TX_AUS: "Austin, TX",
  TX_DAL: "Dallas, TX",
  TX_ELP: "El Paso, TX",
  TX_FTW: "Ft Worth, TX",
  TX_HOU: "Houston, TX",
  TX_LAR: "Laredo, TX",
  TX_LUB: "Lubbock, TX",
  TX_MCA: "McAllen, TX",
  TX_ANT: "San Antonio, TX",
  TX_TEX: "Texarkana, TX",
  UT_SLC: "Salt Lake City, UT",
  VA_ALE: "Alexandria, VA",
  VA_NOR: "Norfolk, VA",
  VA_RCH: "Richmond, VA",
  VA_ROA: "Roanoke, VA",
  VA_WIN: "Winchester, VA",
  WA_SEA: "Seattle, WA",
  WA_SPO: "Spokane, WA",
  WI_EAU: "Eau Claire, WI",
  WI_GRE: "Green Bay, WI",
  WI_MAD: "Madison, WI",
  WI_MIL: "Milwaukee, WI",
  WV_CHA: "Charleston, WV",
  WV_HUN: "Huntington, WV",
  WY_GRE: "Green River, WY",
};
